import React, { useEffect, useState } from "react";
import { Crown, Loader2, Check } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { membership } from "@/lib/api";
import { formatNumber } from "@/lib/format";

const TIERS = [
  { id: "bronze", name: "Bronze", min: 0, color: "amber", bg: "from-amber-50 to-white", benefits: ["Welcome cashback Rp10.000", "Info promo mingguan", "Kode referral otomatis"] },
  { id: "silver", name: "Silver", min: 500000, color: "gray", bg: "from-gray-50 to-white", benefits: ["Cashback 5% setiap order", "Free ongkir 1x/bulan", "Early access sale"] },
  { id: "gold", name: "Gold", min: 2000000, color: "yellow", bg: "from-yellow-50 to-white", benefits: ["Cashback 8% + poin ganda", "Free gift setiap ulang tahun", "Priority customer service", "Early access produk baru"] },
  { id: "platinum", name: "Platinum", min: 5000000, color: "purple", bg: "from-purple-50 to-white", benefits: ["Cashback 12% + VIP treatment", "Free gift setiap 3 bulan", "Direct chat owner", "Exclusive bundling deals", "Free ongkir unlimited"] },
];

export default function Membership() {
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    membership.stats().then(setStats).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const total = Object.values(stats).reduce((s, n) => s + n, 0);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold text-gray-900">Membership Program</h1>
        <p className="text-sm text-gray-500 mt-1">4 tier membership dengan benefit progresif. Upgrade otomatis berdasarkan total spending.</p>
      </div>

      {loading ? <div className="py-12 flex justify-center"><Loader2 className="animate-spin text-emerald-600" /></div>
        : (
          <>
            <div className="grid md:grid-cols-4 gap-4">
              {TIERS.map((t) => (
                <Card key={t.id} className={`border-gray-200 bg-gradient-to-br ${t.bg}`}>
                  <CardContent className="p-5">
                    <div className="flex items-center justify-between">
                      <Crown className={`text-${t.color}-500`} size={20} />
                      <div className="text-xs font-bold tracking-wider uppercase text-gray-500">{t.name}</div>
                    </div>
                    <div className="mt-3 font-heading text-3xl font-bold text-gray-900">{formatNumber(stats[t.id] || 0)}</div>
                    <div className="text-xs text-gray-500">member</div>
                    <div className="mt-2 text-xs text-gray-600">Min. spending: Rp{t.min.toLocaleString("id-ID")}</div>
                  </CardContent>
                </Card>
              ))}
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
              {TIERS.map((t) => (
                <Card key={t.id} className="border-gray-200">
                  <CardContent className="p-6">
                    <Crown className={`text-${t.color}-500`} size={24} />
                    <h3 className="mt-3 font-heading text-lg font-bold text-gray-900">{t.name} Tier</h3>
                    <div className="text-xs text-gray-500 mt-0.5">Total spending Rp{t.min.toLocaleString("id-ID")}+</div>
                    <div className="mt-4 space-y-2">
                      {t.benefits.map((b) => (
                        <div key={b} className="flex items-start gap-2 text-xs text-gray-700">
                          <Check className="text-emerald-600 mt-0.5 flex-shrink-0" size={13} strokeWidth={2.5} />
                          <span>{b}</span>
                        </div>
                      ))}
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>

            <Card className="border-emerald-200 bg-emerald-50/30">
              <CardContent className="p-6">
                <div className="text-xs font-bold uppercase tracking-widest text-emerald-700">Info</div>
                <p className="mt-2 text-sm text-gray-700">
                  Total <b>{formatNumber(total)}</b> pelanggan terdaftar sebagai member. Membership tier di-upgrade otomatis setiap kali pelanggan melewati threshold total spending. Benefit di atas adalah default — sesuaikan di halaman Settings.
                </p>
              </CardContent>
            </Card>
          </>
        )}
    </div>
  );
}
